/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { DisplayItemProps, MainCarriageProps } from '../lxs-anonymous-delivery.data';

const InfoRow: React.FC<DisplayItemProps> = ({ CLASS_NAME, label, value }) => (
    <div className={`${CLASS_NAME}__carriage-info-content-row`}>
        <h6 className={`${CLASS_NAME}__carriage-info-content-row-label`}>{label}</h6>
        <span className={`${CLASS_NAME}__carriage-info-content-row-value`}>{value}</span>
    </div>
);

const MainCarriage: React.FC<MainCarriageProps> = ({ CLASS_NAME, mainCarriage, resources }) => (
    <div className={`${CLASS_NAME}__carriage`}>
        <h4 className={`${CLASS_NAME}__carriage-info-title`}>{resources.lxsAnonymousDeliveryMainCarriageTitle}</h4>
        <div className={`${CLASS_NAME}__carriage-info-content`}>
            {mainCarriage.carrierName && (
                <InfoRow CLASS_NAME={CLASS_NAME} label={resources.lxsAnonymousDeliveryCarrierLabel} value={mainCarriage.carrierName} />
            )}
            {mainCarriage.containerNumber && (
                <InfoRow
                    CLASS_NAME={CLASS_NAME}
                    label={resources.lxsAnonymousDeliveryContainerNumberLabel}
                    value={mainCarriage.containerNumber}
                />
            )}
            {mainCarriage.containerType && (
                <InfoRow
                    CLASS_NAME={CLASS_NAME}
                    label={resources.lxsAnonymousDeliveryContainerTypeLabel}
                    value={mainCarriage.containerType}
                />
            )}
            {mainCarriage.shipNumber && (
                <InfoRow CLASS_NAME={CLASS_NAME} label={resources.lxsAnonymousDeliveryShipNumberLabel} value={mainCarriage.shipNumber} />
            )}
            {mainCarriage.blNumber && (
                <InfoRow CLASS_NAME={CLASS_NAME} label={resources.lxsAnonymousDeliveryBlNumberLabel} value={mainCarriage.blNumber} />
            )}
        </div>
    </div>
);

export default MainCarriage;
